import { formatCurrency } from "./formatNumber";

export const currencySymbols = {
  EUR: "€", // Euro
  GBP: "£", // British Pound
  USD: "$", // US Dollar
  "": "", // Fallback for empty currency string to prevent undefined errors
  // JPY: "¥", // Japanese Yen
  // AUD: "A$", // Australian Dollar
  // CAD: "C$", // Canadian Dollar
  // CHF: "CHF", // Swiss Franc
  // CNY: "¥", // Chinese Yuan
  // SEK: "kr", // Swedish Krona
  // NZD: "NZ$", // New Zealand Dollar
  // INR: "₹", // Indian Rupee
  // RUB: "₽", // Russian Ruble
  // KRW: "₩", // South Korean Won
  // BRL: "R$", // Brazilian Real
  // ZAR: "R", // South African Rand
  // MXN: "$", // Mexican Peso
  // SGD: "S$", // Singapore Dollar
  // HKD: "HK$", // Hong Kong Dollar
  // NOK: "kr", // Norwegian Krone
  // TRY: "₺", // Turkish Lira
  // AED: "د.إ", // UAE Dirham
  // SAR: "﷼", // Saudi Riyal
  // THB: "฿", // Thai Baht
};

export const formatAmount = (amount: string | number, currency: string) =>
  `${currencySymbols[currency]} ${formatCurrency(amount ?? 0, "0,0.00")}`;
